import { valueOf } from "@/types/common";

export const PAYCHECK_CHOSEN_TYPE = {
  UPLOAD_FILE: "1",
  ASK_IROHANA_SUPPORT: "2",
  LOAD_DATA: "3",
};

export type TPaycheckChosenType = valueOf<typeof PAYCHECK_CHOSEN_TYPE>;
